export const advisorWizardConfig_LabelMap = {
    isHpi: 'Is HPI',
    loadFindings: 'Load Findings',
    onlyLoadFindingsFromRTOrder: 'Only Load RTOrder Findings',
};
export const advisorWizardConfig_InfoMap = {
    isHpi: 'This wizard has a single step and a single snippet, the HPI snippet',
    loadFindings: 'This wizard will load findings to its data on open and when findings are updated',
    onlyLoadFindingsFromRTOrder: 'If this wizard is set to load findings, will constrain them to only findings with an RTOrder id matching the context of the wizard',
};
//# sourceMappingURL=consts.js.map